import { configureStore } from '@planter/common';
export var store = configureStore({});
